module.exports = __webpack_public_path__ + "static/media/OpenAI_Logo.2724cb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/OpenAI_Logo.png
// module id = 11
// module chunks = 0